import { ExportConfiguration } from '../export/exportConfiguration';
import { ExportType } from '../export/export';
import { translate } from '../translation/Translator';
import { TranslationKey } from '../translation/TranslationKey';
import { TranslationLanguage } from '../translation/translation';

export const AssetExportConfigurationField = {
  productName: 'productName',
  productNumber: 'productNumber',
  quantity: 'quantity',
  assignedTo: 'assignedTo',
  status: 'status',
  serial: 'serial',
} as const;

export type AssetExportConfigurationField =
  (typeof AssetExportConfigurationField)[keyof typeof AssetExportConfigurationField];

export class AssetExportConfiguration extends ExportConfiguration<AssetExportConfigurationField> {
  static default(companyId: string, language?: TranslationLanguage) {
    return new AssetExportConfiguration({
      companyId,
      name: '',
      type: ExportType.xlsx,
      filename: 'ventory_assets_${TIMESTAMP}',
      mapping: new Map([
        [
          AssetExportConfigurationField.productName,
          { value: translate({ key: TranslationKey.productName, language }), index: 0 },
        ],
        [
          AssetExportConfigurationField.productNumber,
          { value: translate({ key: TranslationKey.productNumber, language }), index: 1 },
        ],
        [
          AssetExportConfigurationField.serial,
          { value: translate({ key: TranslationKey.serial, language }), index: 2 },
        ],
        [
          AssetExportConfigurationField.assignedTo,
          { value: translate({ key: TranslationKey.assignedTo, language }), index: 3 },
        ],
        [
          AssetExportConfigurationField.status,
          { value: translate({ key: TranslationKey.status, language }), index: 4 },
        ],
        [
          AssetExportConfigurationField.quantity,
          { value: translate({ key: TranslationKey.quantity, language }), index: 5 },
        ],
      ]),
    });
  }
}
